import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Forbidden, PageSpinner } from '@ohpen/enso-ui';
import { useAuthz } from '@ohpen/react-authz';

import { getSideBarItems } from '../components/AppLayout/sideBarItems';

const PREFERRED_LANDING_KEY = 'products';

export const DefaultRedirect = () => {
  const { userPermissions, envFeatureFlags, isLoading } = useAuthz();
  const { t } = useTranslation();

  // Landing page is derived from the guarded side bar so it can never point at a
  // surface the route guard denies.
  const landingKey = useMemo(() => {
    const keys = getSideBarItems(userPermissions, envFeatureFlags).flatMap(item =>
      item && item.type !== 'divider' && item.key ? [String(item.key)] : [],
    );
    return keys.includes(PREFERRED_LANDING_KEY) ? PREFERRED_LANDING_KEY : keys[0];
  }, [userPermissions, envFeatureFlags]);

  if (isLoading) return <PageSpinner />;
  if (!landingKey) return <Forbidden showBackButton={false} appName={t('global.title')} />;

  return <Navigate to={landingKey} replace />;
};
